// Global animation config — one source of truth for all pages
export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] }
  }
};

export const fadeUpStagger = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.18, delayChildren: 0.08 }
  }
};

// Viewport config — fires later so elements are well into view before animating
export const viewport = { once: true, margin: '-5%' };